export default "__VITE_ASSET__NpopLbiz__"